import * as Sentry from "@sentry/react";

export const onPostMsgToGrab = (props: { msg: string }) => {
  const { msg } = props;
  const userAgent = navigator.userAgent;
  if (/android/i.test(userAgent)) {
    try {
      (window as any).Grab.postMessage(msg);
    } catch (e) {
      Sentry.captureException(e);
    }
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    try {
      (window as any).webkit.messageHandlers.Grab.postMessage(msg);
    } catch (e) {
      Sentry.captureException(e);
    }
  }
};
